import React from 'react';
import { useParams, Link } from 'react-router-dom';
import { ArrowLeft, Calendar, User, Tag } from 'lucide-react';
import { Button } from '../components/ui/button';
import { Badge } from '../components/ui/badge';
import { blogPosts, contactInfo } from '../mockData';

const BlogPost = () => {
  const { postId } = useParams();
  const post = blogPosts.find(p => p.id === postId);

  if (!post) {
    return (
      <div className="min-h-screen bg-black pt-24 flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-3xl font-bold text-white mb-4">Yazı Bulunamadı</h1>
          <Link to="/blog">
            <Button className="bg-yellow-500 text-black hover:bg-yellow-600">
              Blog'a Dön
            </Button>
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-black pt-24">
      <section className="section-padding">
        <div className="container-custom">
          <div className="max-w-4xl mx-auto">
            <div className="mb-8">
              <Link to="/blog" className="inline-flex items-center text-yellow-500 hover:text-yellow-400">
                <ArrowLeft className="w-4 h-4 mr-2" />
                Tüm Yazılar
              </Link>
            </div>

            <div className="space-y-6">
              <div>
                <Badge className="bg-yellow-500/10 text-yellow-500 border-yellow-500/30 mb-4">
                  {post.category}
                </Badge>
                <h1 className="text-4xl md:text-5xl font-bold text-white mb-6">
                  {post.title}
                </h1>
                <div className="flex items-center gap-6 text-sm text-gray-400">
                  <div className="flex items-center">
                    <User className="w-4 h-4 mr-2" />
                    {post.author}
                  </div>
                  <div className="flex items-center">
                    <Calendar className="w-4 h-4 mr-2" />
                    {new Date(post.date).toLocaleDateString('tr-TR', { 
                      year: 'numeric', 
                      month: 'long', 
                      day: 'numeric' 
                    })}
                  </div>
                </div>
              </div>

              <div className="rounded-2xl overflow-hidden">
                <img 
                  src={post.image} 
                  alt={post.title}
                  className="w-full h-96 object-cover"
                />
              </div>

              <div className="prose prose-lg prose-invert max-w-none">
                <div className="text-gray-300 leading-relaxed whitespace-pre-line">
                  {post.content}
                </div>
              </div>

              {post.tags && post.tags.length > 0 && (
                <div className="pt-6 border-t border-zinc-800">
                  <div className="flex items-center gap-3 flex-wrap">
                    <Tag className="w-4 h-4 text-yellow-500" />
                    {post.tags.map((tag, index) => (
                      <Badge key={index} variant="outline" className="border-zinc-700 text-gray-400">
                        {tag}
                      </Badge>
                    ))}
                  </div>
                </div>
              )}

              <div className="bg-gradient-to-r from-zinc-900 to-zinc-800 rounded-xl p-8 mt-12">
                <h3 className="text-2xl font-bold text-white mb-4">Profesyonel Destek mi Gerekiyor?</h3>
                <p className="text-gray-300 mb-6">
                  EMRE TİCARET olarak tesisat ve su kaçağı konularında size yardımcı olmaya hazırız.
                </p>
                <div className="flex flex-col sm:flex-row gap-4">
                  <a href={`tel:${contactInfo.phones[0].number.replace(/\s/g, '')}`}>
                    <Button className="bg-yellow-500 text-black hover:bg-yellow-600">
                      Hemen Ara
                    </Button>
                  </a>
                  <a href={`https://wa.me/${contactInfo.whatsapp}`} target="_blank" rel="noopener noreferrer">
                    <Button variant="outline" className="border-yellow-500 text-yellow-500 hover:bg-yellow-500 hover:text-black">
                      WhatsApp'tan Yaz
                    </Button>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default BlogPost;
